import { post, request } from "../api";
import { type UniquePageModel } from "@admin/domain/uniquePages/models/UniquePageModel";

type FoundLiveBroadcast = {
    id: string;
    title: string;
};

export async function updateUniquePage(
    id: UniquePageModel<unknown>[`id`],
    body: FormData,
): Promise<UniquePageModel<unknown>> {
    return await post({
        url: `/admin/unique_pages/${id}`,
        body: body,
    });
}

export const searchLiveBroadcasts = async (): Promise<FoundLiveBroadcast[]> => {
    return await request({
        url: `/admin/unique_pages/live_broadcasts/search`,
    });
};
